import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { media } from '../../styles/media';
import { Link } from 'react-router-dom';

const CookieWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #2B2D42;
  padding: 15px 25px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: ${props => props.isVisible ? 'flex' : 'none'};
  align-items: center;
  gap: 20px;
  max-width: 90%;
  width: min(90%, 500px);
  z-index: 1000;

  ${media.mobile} {
    flex-direction: column;
    gap: 10px;
    padding: 12px 20px;
    width: calc(100% - 40px);
    margin: 0 20px;
  }
`;

const CookieText = styled.p`
  color: white;
  font-size: 14px;
  margin: 0;
  flex: 1;

  a {
    color: #FF4B8F;
    text-decoration: underline;
    display: inline;
    margin-left: 5px;
    
    &:hover {
      color: #E62E6F;
    }
  }

  ${media.mobile} {
    font-size: 13px;
    text-align: center;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  white-space: nowrap;
  
  ${media.mobile} {
    width: 100%;
    justify-content: center;
  }
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  
  ${media.mobile} {
    padding: 8px 12px;
    font-size: 13px;
  }
`;

const AcceptButton = styled(Button)`
  background: #FF4B8F;
  color: white;
  border: none;
  
  &:hover {
    background: #E62E6F;
  }
`;

const DeclineButton = styled(Button)`
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  
  ${media.sm`
    gap: 12px;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    
    p {
      margin: 0;
      font-size: 13px;
      line-height: 1.4;
    }
  `}
`;

const CookieConsent = () => {
  const { t, i18n } = useTranslation('legal');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Устанавливаем английский язык по умолчанию
    if (!localStorage.getItem('i18nextLng')) {
      i18n.changeLanguage('en');
    }
    
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, [i18n]);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    // При отказе просто скрываем баннер, не сохраняя в localStorage
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <CookieWrapper isVisible={isVisible}>
      <Content>
        <CookieText>
          {t('cookieConsent.message')} <Link to="/cookie-policy">{t('cookieConsent.policy')}</Link>
        </CookieText>
        <ButtonGroup>
          <AcceptButton onClick={handleAccept}>
            {t('cookieConsent.accept')}
          </AcceptButton>
          <DeclineButton onClick={handleDecline}>
            {t('cookieConsent.decline')}
          </DeclineButton>
        </ButtonGroup>
      </Content>
    </CookieWrapper>
  );
};

export default CookieConsent;